var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMiniLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 12,
    viewBox: "0 0 47 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_784_17715",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.67262 2.33631H2.33631V0.0444072H0V11.7309H2.33631V4.67508H4.67262V2.33877V2.33631ZM4.67262 7.0558H7.00892V4.71949H4.67262V7.0558ZM9.3477 2.33631H7.01139V4.67261H9.3477V11.7284H11.684V0.0419396H9.3477V2.33384V2.33631ZM15.7941 0.0444072H13.4578V11.7309H15.7941V7.01139H18.1304V11.7309H20.4667V0.0444072H15.7917H15.7941ZM18.1304 4.67508H15.7941V2.38318H18.1304V4.67508ZM22.3269 11.6865H24.6632V0H22.3269V11.6865ZM31.2601 2.29437H28.9238V0.00246571H26.5875V11.6889H28.9238V4.63314H31.2601V2.29683V2.29437ZM31.2601 7.01386H33.5965V4.67755H31.2601V7.01386ZM35.9352 2.29437H33.5989V4.63067H35.9352V11.6865H38.2715V0H35.9352V2.2919V2.29437ZM44.6612 0.0444072V9.39211H42.3249V0.0444072H39.9886V11.7309H47V0.0444072H44.6637H44.6612Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_784_17715)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.0566406,
    y: -0.0172577,
    width: 47.0715,
    height: 11.7827,
    fill: "#B0B0B0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLogo);
export default __webpack_public_path__ + "static/media/MiniLogo.b4a7a096c69d5af2ffc16e93c0ee2133.svg";
export { ForwardRef as ReactComponent };